export function highlightText() {
  const goToStack = document.querySelectorAll('a[href^="#"]');

  goToStack.forEach((elem) => {
    elem.addEventListener("click", (event) => {
      const goToId = elem.getAttribute("href");
      if (!goToId || goToId === "#") return;

      const toHighlight = document.querySelector(goToId);
      if (!toHighlight) return;

      event.preventDefault();

      toHighlight.scrollIntoView({ behavior: "smooth", block: "center" });

      toHighlight.style.transition = "background-color 1s ease-out";
      toHighlight.style.backgroundColor = "#6CDB8B";

      if (typeof toHighlight.focus === "function") {
        toHighlight.focus();
      }

      setTimeout(() => {
        toHighlight.style.backgroundColor = "transparent";
      }, 1000);
    });
  });
}
